import { Component, input, output, computed, signal, ChangeDetectionStrategy } from '@angular/core';
import { Board } from '../../models/board.model';

@Component({
  selector: 'app-board-card',
  templateUrl: './board-card.html',
  styleUrl: './board-card.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoardCard {
  // Inputs
  board = input.required<Board>();

  // Outputs
  copyUrl = output<string>();
  edit = output<string>();
  preview = output<string>();
  openInNewWindow = output<string>();
  delete = output<string>();

  // UI state
  protected readonly urlCopied = signal(false);

  // Computed values
  statusLabel = computed(() => {
    const status = this.board().status;
    return status.toUpperCase();
  });

  statusClasses = computed(() => {
    const status = this.board().status;
    return {
      'bg-green-500': status === 'active',
      'bg-rail-gray': status === 'draft',
      'bg-signal-orange': status === 'archived',
    };
  });

  boardDimensions = computed(() => {
    const config = this.board().config;
    return `${config.rows}×${config.columns}`;
  });

  messageCount = computed(() => {
    return this.board().messages.length;
  });

  viewCount = computed(() => {
    const count = this.board().viewCount;
    if (count >= 1000) {
      return `${(count / 1000).toFixed(1)}k`;
    }
    return count.toString();
  });

  // Event handlers
  onCardClick() {
    // Clicking the card opens it for editing
    this.edit.emit(this.board().id);
  }

  onCopyUrl() {
    this.copyUrl.emit(this.board().id);

    // Show visual feedback
    this.urlCopied.set(true);

    // Reset after 2 seconds
    setTimeout(() => {
      this.urlCopied.set(false);
    }, 2000);
  }

  onEdit() {
    this.edit.emit(this.board().id);
  }

  onPreview() {
    this.preview.emit(this.board().id);
  }

  onOpenInNewWindow() {
    this.openInNewWindow.emit(this.board().id);
  }

  onDelete() {
    this.delete.emit(this.board().id);
  }
}
